// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit"
import { toast } from "react-toastify"

// If  websocket response message returns action property:

export const affiliateProgramSlice = createSlice({
  name: "affiliateProgram",
  initialState: {},

  reducers: {
    getReferrals: (state, action) => {
      state.referrals = action.payload.referrals
      console.log(action.payload)
    },
    getAffiliateCommissions: (state, action) => {
      state.commissions = action.payload.affiliateCommissions
      console.log(action.payload)
    }
  }
})

export const { getReferrals, getAffiliateCommissions } = affiliateProgramSlice.actions

export default affiliateProgramSlice.reducer
